import { render, staticRenderFns } from "./UserRefferalList.vue?vue&type=template&id=6f2c015b&lang=html"
import script from "./UserRefferalList.vue?vue&type=script&lang=js"
export * from "./UserRefferalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports